import React, { useEffect, useMemo, useState, useCallback, useContext, useRef } from 'react';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  arrayUnion,
  runTransaction,
} from 'firebase/firestore';
import { AppContext } from './AppContext';

import downloadOnIphone from './assets/downloadOnIphone.png';
import downloadOnGoogle from './assets/downloadOnGoogle.png';


// App Store links
const IOS_APP_STORE_URL = "https://apps.apple.com/us/app/spndat/id6503178936";
const ANDROID_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.spndat.spndat";

// Universal/App Links base (must be your https domain)
const UNIVERSAL_LINK_HOST = "https://spndat.com";

// Direct iOS store scheme (skips Safari)
const IOS_STORE_DIRECT = "itms-apps://itunes.apple.com/app/id6503178936";


// Simple UA checks
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isMobile = () => isIOS() || isAndroid();

const isIGOrFBInApp = () => {
  const ua = navigator.userAgent || '';
  const ref = document.referrer || '';
  return /Instagram|FBAN|FBAV|FB_IAB/i.test(ua) || /instagram\.com|facebook\.com/i.test(ref);
};









// Optional default profile image if none is found
const DEFAULT_PROFILE_URL =
  'https://firebasestorage.googleapis.com/v0/b/spndat-7d730.appspot.com/o/profile_pictures%2FjKG6lpkSmZTKXMXxS4Mm0kRdgKK2?alt=media&token=d10994a2-f842-47bf-84f5-766f44eb7afe';


  
const styles = {
  root: {
    position: 'relative',
    backgroundColor: '#0e061e',
    minHeight: '900px', // fixed px to satisfy the request
    width: '100%',
    overflow: 'hidden',
  },
  bgImage: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',   // using 100% for the full-bleed background is standard on web
    height: '100%',  // it won’t interfere with your px-based component sizing
    objectFit: 'cover',
    zIndex: 0,
    pointerEvents: 'none',
  },
  overlayImage: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 3,
    pointerEvents: 'none',
  },
  screen: {
    position: 'relative',
    zIndex: 2,
    paddingTop: '110px',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '40px',
    minHeight: '760px',
    bottom: '80px'
  },
  headerWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '18px',
  },
  headerTitle: {
    color: 'white',
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    textAlign: 'center',
    fontFamily: 'brhendrix, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    width: '720px',
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderRadius: '16px',
    paddingTop: '18px',
    paddingBottom: '18px',
    paddingLeft: '28px',
    paddingRight: '28px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  avatar: {
    width: '254px',   // 52% of 720px ≈ 374px (kept px as requested)
    height: '254px',
    borderRadius: '187px',
    objectFit: 'cover',
    backgroundColor: '#222',
  },
  usernameText: {
    marginTop: '14px',
    color: 'white',
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center',
    fontFamily: 'brhendrix, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    maxWidth: '640px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  voteBtn: {
    marginTop: '20px',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '56px',
    paddingRight: '56px',
    borderRadius: '12px',
    backgroundColor: '#62fbfa',
    cursor: 'pointer',
    border: 'none',
    transition: 'opacity .2s ease',
  },
  voteBtnDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  voteBtnText: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: '20px',
  },
  copyBtn: {
    marginTop: '14px',
    paddingTop: '6px',
    paddingBottom: '9px',
    paddingLeft: '37px',
    paddingRight: '37px',
    borderRadius: '12px',
    backgroundColor: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#62fbfa',
    cursor: 'pointer',
    color: '#62fbfa',
    fontWeight: 'bold',
    fontSize: '17px',
  },
  linkPreview: {
    marginTop: '12px',
    color: '#b8b8b8',
    fontSize: '16px',
    textAlign: 'center',
    maxWidth: '640px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  linkPreview2: {
    marginTop: '12px',
    color: 'white',
    fontSize: '18px',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '20px',
    color: '#62fbfa',
    fontSize: '16px',
    textAlign: 'center',
  },
  storeWrap: {
  width: '720px',
  backgroundColor: 'rgba(255,255,255,0.04)',
  borderRadius: '16px',
  paddingTop: '24px',
  paddingBottom: '36px',
  paddingLeft: '28px',
  paddingRight: '28px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
},
storeTitle: {
  color: '#fff',
  fontSize: '22px',
  fontWeight: 'bold',
  textAlign: 'center',
  marginBottom: '18px',
},
badgeRow: {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
},
badgeImg: {
  width: '160px',
  height: '202px',
  objectFit: 'contain',
  cursor: 'pointer',
},

};

const ShowcaseArtistViewWeb = () => {
  const [entries, setEntries] = useState([]); // kept for parity with your earlier structure

  const { userId2 } = useContext(AppContext);

  const db = getFirestore();


  const [showStoreBadges, setShowStoreBadges] = useState(false);

const openAppOrStore = (username) => {
setShowStoreBadges(true);
};

  const docRef = useMemo(
    () => doc(db, 'artistShowcase', 'signups'),
    [db]
  );

  // Parse /showcase/:username from the current URL
  const initialFromPath = (() => {
    try {
      const parts = window.location.pathname.split('/').filter(Boolean);
      if (parts[0] === 'showcase' && parts[1]) return decodeURIComponent(parts[1]);
    } catch {}
    return '';
  })();

  // Route-like params (web)
  const [userId, setUserId] = useState(''); // if you support /showcase?userId=... you could parse it from search params
  const [username, setUsername] = useState(initialFromPath);
  const [profileImageUrl, setProfileImageUrl] = useState('');
  const [loading, setLoading] = useState(!!initialFromPath && !profileImageUrl);

  // Voting UI state
  const [submittingVote, setSubmittingVote] = useState(false);
  const [hasVotedThis, setHasVotedThis] = useState(false);
  const [hasVotedAnywhere, setHasVotedAnywhere] = useState(false);
  const [votesCount, setVotesCount] = useState(0);

  const [copying, setCopying] = useState(false);

  const isFacebookInApp = () => /FBAN|FBAV|FB_IAB|FBIOS|FBAN\/Messenger/i.test(navigator.userAgent);
const isInstagramInApp = () => /Instagram/i.test(navigator.userAgent);
const isTwitterInApp = () => /\bTwitter\b/i.test(navigator.userAgent);
const isTikTokInApp = () => /TikTok/i.test(navigator.userAgent);
const isInAppBrowser = () =>
  isFacebookInApp() || isInstagramInApp() || isTwitterInApp() || isTikTokInApp();


  const shareLink = useMemo(() => {
    const uname = username ? encodeURIComponent(username) : '';
    return `https://spndat.com/showcase/${uname}`;
  }, [username]);

  const fetchArtistFromSignups = useCallback(async (uid) => {
    if (!uid) return;
    try {
      setLoading(true);
      const snap = await getDoc(docRef);
      if (!snap.exists()) return;

      const data = snap.data() || {};
      const artistsMap = data.artists || {};
      const arr = Array.isArray(artistsMap[uid]) ? artistsMap[uid] : [];

      // compute hasVotedAnywhere across all artists while we have the doc
      let votedAnywhere = false;
      for (const arrRaw of Object.values(artistsMap)) {
        const a = Array.isArray(arrRaw) ? arrRaw : [];
        const latest = a.length ? a[a.length - 1] : null;
        if (Array.isArray(latest?.voters) && userId2 && latest.voters.includes(userId2)) {
          votedAnywhere = true;
          break;
        }
      }
      setHasVotedAnywhere(votedAnywhere);

      if (arr.length) {
        const latest = arr[arr.length - 1];
        const voters = Array.isArray(latest?.voters) ? latest.voters : [];
        setUsername(latest?.username || '');
        setProfileImageUrl(latest?.profileImageUrl || latest?.profileImageURL || '');
        setVotesCount(typeof latest?.votesCount === 'number' ? latest.votesCount : 0);
        setHasVotedThis(userId2 ? voters.includes(userId2) : false);
      } else {
        setUsername('');
        setProfileImageUrl('');
        setVotesCount(0);
        setHasVotedThis(false);
      }
    } catch (e) {
      console.error('ShowcaseArtistViewWeb fetch by uid error:', e);
    } finally {
      setLoading(false);
    }
  }, [docRef, userId2]);

  const fetchArtistFromSignupsByUsername = useCallback(async (uname) => {
    if (!uname) return;
    try {
      setLoading(true);
      const snap = await getDoc(docRef);
      if (!snap.exists()) return;

      const data = snap.data() || {};
      const artistsMap = data.artists || {};

      let foundUid = '';
      let latest = null;

      // also compute hasVotedAnywhere while scanning
      let votedAnywhere = false;

      Object.keys(artistsMap).forEach((uid) => {
        const arr = Array.isArray(artistsMap[uid]) ? artistsMap[uid] : [];
        const last = arr[arr.length - 1] || {};
        const voters = Array.isArray(last?.voters) ? last.voters : [];
        if (userId2 && voters.includes(userId2)) {
          votedAnywhere = true;
        }
        if ((last.username || '').toLowerCase() === uname.toLowerCase()) {
          foundUid = uid;
          latest = last;
        }
      });

      setHasVotedAnywhere(votedAnywhere);

      if (foundUid && latest) {
        const voters = Array.isArray(latest?.voters) ? latest.voters : [];
        setUserId(foundUid);
        setUsername(latest.username || '');
        setProfileImageUrl(latest.profileImageUrl || latest.profileImageURL || '');
        setVotesCount(typeof latest?.votesCount === 'number' ? latest.votesCount : 0);
        setHasVotedThis(userId2 ? voters.includes(userId2) : false);
      } else {
        setProfileImageUrl(''); // not found
        setVotesCount(0);
        setHasVotedThis(false);
      }
    } catch (e) {
      console.error('ShowcaseArtistViewWeb fetch by username error:', e);
    } finally {
      setLoading(false);
    }
  }, [docRef, userId2]);

  useEffect(() => {
    if (userId && (!username || !profileImageUrl)) {
      fetchArtistFromSignups(userId);
    } else if (!userId && username && !profileImageUrl) {
      fetchArtistFromSignupsByUsername(username);
    } else if (username && profileImageUrl) {
      // still ensure hasVotedAnywhere is set
      fetchArtistFromSignupsByUsername(username);
    } else {
      setLoading(false);
    }
  }, [userId, username, profileImageUrl, fetchArtistFromSignups, fetchArtistFromSignupsByUsername]);

  

  const handleCopyLink = async () => {
    try {
      if (!username) {
        window.alert('Unavailable: Username is missing for this artist.');
        return;
      }
      setCopying(true);
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareLink);
      } else {
        // Fallback
        const ta = document.createElement('textarea');
        ta.value = shareLink;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      window.alert('Link Copied. Share this link to open the artist’s showcase page.');
    } catch (e) {
      console.error('Copy link error:', e);
      window.alert('Error: Could not copy the link. Please try again.');
    } finally {
      setCopying(false);
    }
  };

  const handleVoteNow = async () => {

        openAppOrStore(username);

  };

  const voteDisabled = submittingVote || hasVotedThis || (hasVotedAnywhere && !hasVotedThis);
  const voteLabel =
    submittingVote ? 'Please wait…' :
    hasVotedThis ? 'Voted' :
    'Download To Vote';

  return (
    <div style={styles.root}>
      <div style={styles.screen}>
        <div style={styles.headerWrap}>
          <div style={styles.headerTitle}>20k GIVEAWAY SHOWCASE</div>
        </div>

        {loading ? (
          <div style={styles.spinner}>Loading…</div>
        ) : (
<div style={styles.content}>
  {showStoreBadges ? (
    <div style={styles.storeWrap}>
      <div style={styles.storeTitle}>Download the app to vote!</div>
      <div style={styles.badgeRow}>
        <img
          src={downloadOnIphone}
          alt="Download on iOS"
          style={styles.badgeImg}
          onClick={() => window.open(IOS_APP_STORE_URL, '_blank')}
        />
        <img
          src={downloadOnGoogle}
          alt="Get it on Google Play"
          style={styles.badgeImg}
          onClick={() => window.open(ANDROID_PLAY_STORE_URL, '_blank')}
        />
      </div>
    </div>
  ) : (
    <div style={styles.card}>
      <img
        src={profileImageUrl || DEFAULT_PROFILE_URL}
        alt={username || 'unknown'}
        style={styles.avatar}
      />

      <div style={styles.usernameText} title={username || 'unknown'}>
        {username || 'unknown'}
      </div>

      <button
        type="button"
        style={{
          ...styles.voteBtn,
          ...(voteDisabled ? styles.voteBtnDisabled : {}),
        }}
        onClick={handleVoteNow}
        disabled={voteDisabled}
      >
        <span style={styles.voteBtnText}>
          {voteLabel}
        </span>
      </button>

      <button
        type="button"
        style={{
          ...styles.copyBtn,
          opacity: copying || !username ? 0.7 : 1,
        }}
        onClick={handleCopyLink}
        disabled={copying || !username}
      >
        {copying ? 'Copying…' : 'Copy Link'}
      </button>

      {!!username && (
        <div style={styles.linkPreview} title={shareLink}>
          {shareLink}
        </div>
      )}

      <div style={styles.linkPreview2}>Voting is 100% Free</div>
    </div>
  )}
</div>

        )}
      </div>

    </div>
  );
};

export default ShowcaseArtistViewWeb;
